import script from "./BaseFinderHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseFinderHeader.vue?vue&type=script&setup=true&lang=js"

import "./BaseFinderHeader.vue?vue&type=style&index=0&id=f5a70de6&scoped=true&lang=css"

import exportComponent from "/Users/lulua/Documents/lupanalua_oficial+dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5a70de6"]])

export default __exports__